import React, { useState } from 'react';
import moment from 'moment';

import { I18n } from 'aws-amplify';

import {
    Table,
    Popconfirm,
    notification,
    DatePicker,
    Button,
    Checkbox,
    Tooltip,
    Icon,
    Tag
} from 'antd';

const dateFormat = 'DD/MM/YYYY';

export const ClientDueDateForm = ({ invoice = {}, update_billing_installment_invoice_due_date, onDismiss }) => {

    const [clientDueDate, setClientDueDate] = useState(invoice.clientDueDate);
    const [busy, setBusy] = useState(false);

    const onSave = (e, data) => {

        e.preventDefault();

        setBusy(true);

        update_billing_installment_invoice_due_date(data).then((response) => {

            setBusy(false);
            
            notification.success({
                message: I18n.get("Atualizado com sucesso!"),
            });

            onDismiss();

        }).catch(error => {

            setBusy(false);
            
            if(Object.keys(error?.response?.data).length > 0){
                
                Object.keys(error?.response?.data).map(item => {
                    notification.error({
                        message: I18n.get("Ops! Algo deu errado."),
                        description: error?.response?.data[item].errorMessage,
                      });

                });
            }
        });

        return false;
    }

    return (
        <form style={{ display: 'inline-flex', padding: '0.25rem' }}>

            <DatePicker size='small' defaultValue={moment(clientDueDate, dateFormat)} format={dateFormat} onChange={(date, dateString) => setClientDueDate(dateString)} />

            <Button onClick={(e) => onSave(e, { ...invoice, clientDueDate })} loading={busy} className="button bt-bpool black" style={{ marginLeft: '0.25rem' }}>
                {I18n.get("Salvar")}
            </Button>

            <div style={{ padding: '0.5rem', fontSize: '90%' }}>

                <a onClick={e => onDismiss()}>{I18n.get('Cancelar')}</a>

            </div>
        
        </form>
    );
}
